import _ from 'underscore';
import Backbone from 'backbone';

import TrackerCollection from 'core/collections/tracker';
import MoodBooster from 'models/mood_booster';


export default TrackerCollection.extend({
  model: MoodBooster,
  comparator: 'mood_avg',
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'mood-booster',
  }),

  calculate_top_boosters: function () {
    var personals = this.where({ isPersonal: true });
    if (!personals.length) {
      return;
    }
    var max_mood = _.last(personals).get('mood_avg');
    var min_mood = _.first(personals).get('mood_avg');
    var eighty_five = 0.85 * (max_mood - min_mood) + min_mood;
    _.each(personals, function (booster) {
      var isTop = booster.get('mood_avg') >= eighty_five;
      booster.set('isTop', isTop);
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/mood_booster.js